import { useCallback } from 'react';

/** Minimal clipboard hook with a transient "Copied" state (F-049). */
export function useClipboard(): {
  copy: (text: string) => Promise<void>;
} {
  const copy = useCallback(async (text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Fallback for non-secure contexts / older browsers.
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch {
        // last-resort: ignore
      }
      document.body.removeChild(ta);
    }
  }, []);

  return { copy };
}
